import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateToView } from "helpers/date";
import { invoiceTriggerTypes, paymentPeriodTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import { rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { list as legalPersons } from "sources/books/legalPersons";

class CounterpartyContracts extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id, isMain },
                    },
                }) => (
                    <>
                        <Link to={paths.counterpartyContractsShow(this.props.match.params.counterpartyId, id)}>
                            {value}
                        </Link>
                        {isMain && (
                            <>
                                <br />
                                <span className="badge basge-pill badge-primary">Основной договор</span>
                            </>
                        )}
                    </>
                ),
            },
            {
                Header: "Номер",
                accessor: "number",
                filterable: true,
            },
            {
                Header: "Дата договора",
                accessor: "date",
                sortable: false,
                Cell: ({ value }) => dateToView(value),
                CSVExport: ({ value }) => dateToView(value),
            },
            {
                Header: "Организация",
                accessor: "legalPersonName",
                id: "legalPersonId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: legalPersons, inputProps: { name: "legalPersonId" }, propName: "name" }}
                    />
                ),
            },
            {
                Header: "Валюта взаиморасчета",
                accessor: "settlementCurrency",
                filterable: true,
            },
            {
                Header: "Основание для выставления счёта",
                accessor: "invoiceTriggerType",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "type" },
                            options: invoiceTriggerTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(invoiceTriggerTypes, value),
                CSVExport: ({ value }) => enumLabel(invoiceTriggerTypes, value),
            },
            {
                Header: "Срок оплаты",
                accessor: "paymentPeriod",
                filterType: "int",
                filterable: true,
            },
            {
                Header: "Вариант срока оплаты",
                accessor: "paymentPeriodType",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "type" },
                            options: paymentPeriodTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(paymentPeriodTypes, value),
                CSVExport: ({ value }) => enumLabel(paymentPeriodTypes, value),
            },
            {
                Header: "Тип оплаты",
                accessor: "paymentTypeId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "paymentTypeId" },
                            options: this.props.enums.paymentType,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(this.props.enums.paymentType, value),
                CSVExport: ({ value }) => enumLabel(this.props.enums.paymentType, value),
            },
            {
                Header: "Лимит задолженности",
                accessor: "debtCeiling",
                filterable: true,
                filterType: "int",
            },
            {
                Header: "Текущая задолженность",
                accessor: "currentDebt",
                filterable: true,
                filterType: "int",
            },
        ];
    }

    renderCreateButton = () => {
        const { match, roles } = this.props;
        if (!(roles.isTruckingOrganizationAdmin || roles.isIntegrationManager || roles.isTruckingOrganizationManager)) {
            return null;
        }
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.counterpartyContractsNew(match.params.counterpartyId),
        };
        return <Link {...props}>Добавить новый договор</Link>;
    };

    render() {
        const { getList, ...props } = this.props;
        return (
            <div className="container-fluid h-100 pb-3">
                <div className="card card-body h-100">
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex justify-content-end pb-3">{this.renderCreateButton()}</div>
                        <div className="flex-grow-1 overflow-hidden">
                            <SharedReactTable
                                {...props}
                                source={{
                                    ...props.source,
                                    getListExcel: (params) =>
                                        props.source.getListExcel({
                                            ...params,
                                            counterpartyId: parseInt(props.match.params.counterpartyId),
                                        }),
                                }}
                                wrapCname="h-100"
                                getList={(params) =>
                                    getList({ ...params, counterpartyId: parseInt(props.match.params.counterpartyId) })
                                }
                                columns={this.state.tableColumns}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default tableContainer(CounterpartyContracts, "counterparty-contracts");
